import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import { Text, ButtonLink, FormContainer } from "areas/order/components"
import { jewlr_t } from "helpers/application"

const Complete = ({ orderData }) => {
  console.log(orderData)
  return (
    <FormContainer>
      <Text fontSize={25} width={{ _: "82%", tablet: "100%" }}>
        Your Upgrade {jewlr_t("terms.Shipping")} Request Has Been Submitted
      </Text>
      <Text mb={5} mx={{ _: 3, tablet: "auto" }}>
        Your Upgrade {jewlr_t("terms.Shipping")} request has been submitted will
        be processed in 1-2 business days.
        <Box as="br" display={{ _: "none", tablet: "block" }} /> Further
        instructions will be sent to your email.
      </Text>

      <ButtonLink data-lc="complete" to="/" variant="primary">
        Continue Shopping
      </ButtonLink>
    </FormContainer>
  )
}

Complete.propTypes = {
  orderData: PropTypes.object,
}

export default Complete
